import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import useApplyFilters from '~/core/filters/hooks/useApplyFilters';

export const ButtonListFilterControl = props => {
	const { toggleFilter } = useApplyFilters();

	const [filterOptions, setFilterOptions] = useState([]);
	const [isOpenedFilter, setOpenedFilter] = useState('false');

	const handleToggle = () => {
		setOpenedFilter(!isOpenedFilter);
	};

	useEffect(() => {
		if (props.filter == null || props.filter.items.length == 0) {
			return;
		}

		var list = [];

		for (let item of props.filter.items) {
			list.push(item);
		}

		setFilterOptions(list);
	}, [props.filter]);

	// Apply filter without page refresh...
	const handleFilterClick = (event, url) => {
		event.preventDefault();
		toggleFilter(url);
	};

	const renderFilterButtons = filterList => {
		var controls = [];
		// Render filters
		for (let fv of filterList) {
			//// Category filter is a simple link
			//let filterUrl = props.filter.tp == 1
			// ? "/categories/" + fv.url
			// : location.pathname + "?" + fv.url;

			// Category filter as normal filter
			let filterUrl = fv.url;
			// Check fv.chex for applying color rectangle, also check props.filter.tp to determine filter type
			// Check fv.sel to apply UI for showing filter selected
			controls.push(
				<li key={'lnk-bflt-' + fv.vl} className={fv.sel ? 'choosen' : null}>
					<Link
						className={fv.product_count == 0 ? 'flex-col disabled' : 'flex-col'}
						to={filterUrl}
						onClick={e => {
							handleFilterClick(e, filterUrl);
						}}>
						{fv.chex != null ? <div className="fil-col" style={{ backgroundColor: fv.chex }}></div> : null}
						{fv.vl} ({fv.product_count})
					</Link>
					{/*<Link*/}
					{/*	className='flex-col'*/}
					{/*	to={filterUrl}*/}
					{/*	onClick={e => {*/}
					{/*		handleFilterClick(e, filterUrl);*/}
					{/*	}}>*/}
					{/*	{fv.chex != null ? <div className="fil-col" style={{ backgroundColor: fv.chex }}></div> : null}*/}
					{/*	{fv.vl} */}
					{/*</Link>*/}
				</li>
			);
		}

		return (
			<div className="filter-content">
				<strong className={!isOpenedFilter ? 'active-filter' : null} onClick={handleToggle}>
					{props.placeholder}
				</strong>
				{!isOpenedFilter ? <ul className={'grid-col filter-items ' + props.name}>{controls}</ul> : null}
			</div>
		);
	};

	return <li key={'btfltc-' + props.filter.id}>{renderFilterButtons(filterOptions)}</li>;
};

ButtonListFilterControl.propTypes = {
	placeholder: PropTypes.string,
	filter: PropTypes.object,
	name: PropTypes.string
};
